/* eslint-disable import/prefer-default-export */
import useUserStore from 'stores/user';

// Format currency value according to set locale and currency.
export const formatCurrency = (
  value,
  minimumFractionDigits = null,
  maximumFractionDigits = null
) => {
  const userStore = useUserStore.getState();
  const style = {
    style: 'currency',
    currency: userStore.user.currency,
  };
  if (minimumFractionDigits !== null) {
    style.minimumFractionDigits = minimumFractionDigits;
  }
  if (maximumFractionDigits !== null) {
    style.maximumFractionDigits = maximumFractionDigits;
  }
  return Number(value).toLocaleString(userStore.user.region, style);
};
